import { useEffect, useRef } from 'react';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { logger } from '@/services/logger/logger';
import PaymentSuccess from '@/features/paymentProcess/PaymentSuccess';

import { setPayinSent } from './payinSlice';
import { usePayin } from './usePayin';

import RouteProps from '@/types/shared-types';

function PayinPaymentSuccess({ totalSteps, currencySymbol }: RouteProps) {
  const dispatch = useAppDispatch();
  const payinState = useAppSelector(state => state.payin);
  const hasStartedPayin = useRef(false);

  const { triggerPayinApi } = usePayin();

  // Submit payin data on load
  useEffect(() => {
    // Prevent payin API call being sent more than once using a ref
    // This avoids race conditions with state updates that we've been having (DF-243)
    if (hasStartedPayin.current || payinState.payinSent) {
      return;
    }

    // Set the flag immediately after the guard clause to prevent any possibility
    // of multiple executions
    hasStartedPayin.current = true;

    // Mark payin as sent in the store
    dispatch(setPayinSent(true));

    // Trigger payment-service payin submit
    void triggerPayinApi({
      onSuccess: () => {},
      onError: () => {
        logger.error('Error sending Payin');
        // Reset the ref on error so we can try again
        hasStartedPayin.current = false;
      },
    });
  }, [dispatch, payinState.payinSent, triggerPayinApi]);

  return (
    <PaymentSuccess
      totalSteps={totalSteps}
      currencySymbol={currencySymbol}
    />
  );
}

export default PayinPaymentSuccess;
